import Path from "@core/FileProvider/Path/Path";
import type { CategoryLink, ItemLink } from "@ext/navigation/NavigationLinks";

const findMatchingPath = (links: ItemLink[], currentLevels: string[]): ItemLink[] | undefined => {
	for (const link of links) {
		const linkLevels = link.ref.path.split("/");

		const isMatch = currentLevels.every((level, index) => linkLevels[index] === level);

		if (isMatch) return [link];

		const items = (link as CategoryLink).items;
		if (items && items.length > 0) {
			const nestedPath = findMatchingPath(items, currentLevels);
			if (nestedPath) return [link, ...nestedPath];
		}
	}
};

export const getArticleItemLinkPath = (itemLinks: ItemLink[], findPath: string): ItemLink[] => {
	const articlePath = new Path(findPath);
	const levels = articlePath.value.split("/");

	return findMatchingPath(itemLinks, levels) ?? [];
};

const getArticleItemLink = (itemLinks: CategoryLink[] | ItemLink[], findPath: string): ItemLink =>
	getArticleItemLinkPath(itemLinks, findPath).at(-1);

export default getArticleItemLink;
